import Cookies from 'js-cookie'

const TokenKey = 'App-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setRequestAppType(str) {
  return Cookies.set('RequestAppType', str)
}

export function getRequestAppType() {
  return Cookies.get('RequestAppType')
}

export function removeRequestAppType() {
  return Cookies.remove('RequestAppType')
}

// 购买商品信息
const shoppingInforKey = 'shoppingInfor'

export function getShoppingInfor() {
  return Cookies.get(shoppingInforKey)
}

export function setShoppingInfor(shopping) {
  return Cookies.set(shoppingInforKey, shopping)
}

export function removeShoppingInfor() {
  return Cookies.remove(shoppingInforKey)
}

// 支付成功url
const paySuccessURLKey = 'paySuccessUrl'

export function getPaySuccessURL() {
  return Cookies.get(paySuccessURLKey)
}

export function setPaySuccessURL(url) {
  return Cookies.set(paySuccessURLKey, url)
}

export function removePaySuccessURL() {
  return Cookies.remove(paySuccessURLKey)
}

// 支付订单号
const orderNoKey = 'orderNoKey'

export function getPayOrderNo() {
  let json = Cookies.get(orderNoKey),
    obj = {}

  try {
    obj = JSON.parse(json)
  } catch (error) {
    obj = {}
  }

  return obj
}

export function setPayOrderNo(key, value) {
  let o = { key, value }
  return Cookies.set(orderNoKey, o)
}

export function removePayOrderNo() {
  return Cookies.remove(orderNoKey)
}

const successOrderKey = 'successOrderKey'

export function getSuccessOrder(value) {
  return Cookies.get(successOrderKey)[value]
}

export function setSuccessOrder(value) {
  let newValue = getSuccessOrder() || {}
  newValue[value] = true
  return Cookies.set(successOrderKey, newValue)
}

export function checkSuccessOrder(value) {
  return getSuccessOrder(value) || false
}

export function removeSuccessOrder() {
  return Cookies.remove(successOrderKey)
}

/**
 * set商品推荐码
 */
export function setPaymentRecommendCode(productNo, recomentCode) {
  let newValue = {}
  newValue[productNo] = recomentCode
  return Cookies.set('paymentRecommendCodeKey', newValue)
}

/**
 * get商品推荐码
 */
export function getPaymentRecommendCode(productNo) {
  let result = Cookies.get('paymentRecommendCodeKey') || {}
  try {
    result = JSON.parse(result)
  } catch (error) {
    result = {}
  }

  return result[productNo] || ''
}

/**
 * 移除商品推荐码
 */
export function removePaymentRecommendCode() {
  Cookies.remove('paymentRecommendCodeKey')
}

/**
 * set商品优惠券
 */
export function setPaymentCoupons(productNo, coupons) {
  let newValue = {}
  newValue[productNo] = coupons
  return Cookies.set('paymentCouponsKey', newValue)
}

/**
 * get商品优惠券
 */
export function getPaymentCoupons(productNo) {
  let result = Cookies.get('paymentCouponsKey') || {}
  try {
    result = JSON.parse(result)
  } catch (error) {
    result = {}
  }
  return result[productNo] || []
}

/**
 * 移除商品优惠券
 */
export function removePaymentCoupons() {
  Cookies.remove('paymentCouponsKey')
}

/**
 * set支付成功商品
 */
export function setPayProducts(products) {
  return Cookies.set('payProductsKey', products)
}

/**
 * get支付成功商品
 */
export function getPayProducts() {
  let result = Cookies.get('payProductsKey')
  if (Object.prototype.toString.call(result) === '[object Array]') {
    removePayProducts()
    return []
  }
  try {
    result = JSON.parse(result)
  } catch (error) {
    result = []
  }
  return result
}

/**
 * 移除支付成功商品
 */
export function removePayProducts() {
  Cookies.remove('payProductsKey')
}

/**
 * 获取推荐码
 */
export function getRecommendCode() {
  try {
    const cookieValue = Cookies.get('recommend_code')
    if (cookieValue) {
      const recommendCode = JSON.parse(cookieValue)
      // 检查解析结果是否为对象且不为 null
      if (typeof recommendCode === 'object' && recommendCode !== null) {
        return recommendCode
      }
    }
  } catch (error) {
    console.error('从 cookie 获取推荐码时出错:', error)
  }
  // 默认返回空对象
  return {}
}

/**
 * 从 URL 设置推荐码到 cookie
 * @param {object} recommendCode - 推荐码对象
 */
export function setRecommendCode(recommendCode) {
  if (recommendCode && typeof recommendCode === 'object' && recommendCode !== null) {
    try {
      const inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000)
      Cookies.set('recommend_code', JSON.stringify(recommendCode), {
        expires: inTwentyMinutes,
        // 如果你的应用使用了 HTTPS，可以考虑添加 secure: true 选项
        // 同时可以根据需要配置 SameSite 属性
      })
    } catch (error) {
      console.error('设置推荐码到 cookie 时出错:', error)
    }
  } else {
    console.warn('尝试设置无效的推荐码到 cookie:', recommendCode)
  }
}
